function encodeSlug(name) {
  return String(name || '')
    .split(',').join('4')
    .split('&').join('$')
    .split(' ').join('_');
}

module.exports = encodeSlug;



// WEBPACK FOOTER //
// ./js/room-slug.js